
const defaultConfig = {
    header_text: "RS HEADER",
    showsettingkeys: '',
    contact_info: '',
    show_order_group: [
        {
            name: 'tt',
            text: 'Info TT',
            config: {
                show_time: 5,
                font_size: 20,
            }
        },
        {
            name: 'jd',
            text: 'Jadwal Dokter',
            config: {
                show_time: 5,
                font_size: 20,
            }
        },
    ]
};

function setConfig(data) {
    localStorage.setItem('config', JSON.stringify(data));
}

function getFontConfig() {
    let configApp = localStorage.getItem('configApp');
    let jsonConfig = JSON.parse(configApp);
    let fontSize = jsonConfig.ukuranFont;
    return fontSize;
}

async function setInfoKamar(data) {
    localStorage.setItem('info_kamar', JSON.stringify(data));
    return true;
}

function paginate(array, page_size = 10, page_number = 1) {
    --page_number;
    return array.slice(page_number * page_size, (page_number + 1) * page_size);
}

function createPaginatedData(data, perPage = 10) {
    let result = [];
    var hasilBagi = Math.ceil(data.length / perPage);
    var i;
    for (i = 0; i < hasilBagi; i++) {
        var pgData = paginate(data, perPage, i + 1)
        result[i] = pgData;
    }

    return result;
}

function groupDataAndPaginateByKelas(data) {
    var hasil = [];
    var i;

    for (i = 0; i < data.length; i++) {
        var groupName = data[i].kode_alias_vklaim_kelas;
        if (!hasil[groupName]) {
            hasil[groupName] = [];
        }
        hasil[groupName].push(data[i]);
    }

    return hasil;
}

export {
    defaultConfig,
    setConfig,
    setInfoKamar,
    paginate,
    createPaginatedData,
    groupDataAndPaginateByKelas,
    getFontConfig
}

